import { IconBanOutline } from '@iwoca/icons';
import { Pill } from '@iwoca/orion';
import { Text } from '@iwoca/orion-ui';
import { Divider } from '@ui';
import { FormattedMessage } from 'react-intl';

import CreditCardFrozen from '../../images/credit-card-frozen.png';
import CreditCard from '../../images/credit-card.svg';
import { DrawerContent } from '../drawerSlider/DrawerSlider';
import { Card } from '../types';

const CreditCardImage = ({ isFrozen }: { isFrozen: boolean }) => {
    return (
        <img
            src={isFrozen ? CreditCardFrozen : CreditCard}
            // eslint-disable-next-line formatjs/no-literal-string-in-jsx
            alt="Credit Card"
            className="mr-xl h-[48px] w-[72px] max-sm:h-[32px] max-sm:h-[48px]"
        />
    );
};

const StatusPill = ({ status }: { status: string }) => (
    <Pill
        variant="red"
        size="small"
        className="my-auto ml-l h-xl py-0 max-sm:ml-0"
        // eslint-disable-next-line formatjs/no-literal-string-in-jsx
        aria-label="status-pill"
    >
        <Text className="text-error-50 flex flex-row items-center gap-xs text-s font-med">
            {status}
            <IconBanOutline />
        </Text>
    </Pill>
);

export const CreditCardItem = ({
    card,
    setDrawerContent
}: {
    card: Card;
    setDrawerContent: (content: DrawerContent) => void;
}) => {
    const statusPills = {
        active: null,
        frozen: <StatusPill status={'Frozen'} />,
        blocked: <StatusPill status={'Blocked'} />,
        closed: <StatusPill status={'Closed'} />,
        lost_or_stolen: <StatusPill status={'Reported lost / stolen'} />,
        expired: <StatusPill status={'Expired'} />
    };

    return (
        <>
            <Divider className="mt-xl" />
            <div
                className={`flex flex-row items-center py-xl max-sm:items-start ${card.status === 'lost_or_stolen' ? 'opacity-60' : ''}`}
                // eslint-disable-next-line formatjs/no-literal-string-in-jsx
                aria-label="credit-card-item"
            >
                <CreditCardImage isFrozen={card.status === 'frozen'} />
                <div className="flex flex-row items-start gap-s max-sm:flex-col">
                    <div className="flex flex-col items-start">
                        <Text className="m-0 text-l font-med text-primary-10">
                            <FormattedMessage
                                id="_.credit_card.dashboard.card_name"
                                defaultMessage="iwoca Credit Card * * * * {lastFourDigits}"
                                values={{
                                    lastFourDigits: card.last_four_digits
                                }}
                            />
                        </Text>
                        {(card.status === 'active' ||
                            card.status === 'frozen') && (
                            <button
                                onClick={() =>
                                    setDrawerContent('cardUsageLimits')
                                }
                                className="border-0 bg-transparent p-0 text-left"
                            >
                                <Text className="m-0 cursor-pointer text-s font-reg text-primary-40 underline">
                                    <FormattedMessage
                                        id="_.credit_card.dashboard.new_card.lost_and_stolen.title"
                                        defaultMessage="View usage limits"
                                    />
                                </Text>
                            </button>
                        )}
                    </div>
                    {statusPills[card.status]}
                </div>
            </div>
        </>
    );
};
